"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactIntl = require("react-intl");
const monthKeys = (0, _reactIntl.defineMessages)({
  january: {
    id: "common.months.january"
  },
  february: {
    id: "common.months.february"
  },
  march: {
    id: "common.months.march"
  },
  april: {
    id: "common.months.april"
  },
  may: {
    id: "common.months.may"
  },
  june: {
    id: "common.months.june"
  },
  july: {
    id: "common.months.july"
  },
  august: {
    id: "common.months.august"
  },
  september: {
    id: "common.months.september"
  },
  october: {
    id: "common.months.october"
  },
  november: {
    id: "common.months.november"
  },
  december: {
    id: "common.months.december"
  }
});
const months = [monthKeys.january, monthKeys.february, monthKeys.march, monthKeys.april, monthKeys.may, monthKeys.june, monthKeys.july, monthKeys.august, monthKeys.september, monthKeys.october, monthKeys.november, monthKeys.december];
var _default = exports.default = months;